/* eslint-disable */
import SearchController from '../common/SearchController';

$(() => {
	const searchController = new SearchController({
		el: 'body'
	});

	searchController.initSearchOnScroll();
});
